/* variant-explanation-info.js */
(() => {
  const toHandle = (str) => (str || '')
    .toString()
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '') // Akzente raus
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')                      // nicht-alnum -> "-"
    .replace(/^-+|-+$/g, '');                         // trim "-"

  const updateInfo = (info) => {
    const selector = info.closest('.option-selector');
    if (!selector) return;

    let value = '';

    if (selector.dataset.selectorType === 'dropdown') {
      const btn = selector.querySelector('.custom-select__btn');
      value = btn ? btn.textContent.trim() : '';

      // Placeholder berücksichtigen (dein VariantPicker nutzt dataset.placeholderText)
      const picker = info.closest('variant-picker');
      const placeholder = picker?.dataset?.placeholderText;
      if (placeholder && value === placeholder) value = '';
    } else {
      const checked = selector.querySelector('input[type="radio"]:checked');
      value = checked ? checked.value : '';
    }

    const key = toHandle(value);
    const panels = info.querySelectorAll('[data-explanation-key]');

    let shown = false;
    panels.forEach((p) => {
      const match = key && p.dataset.explanationKey === key;
      p.hidden = !match;
      if (match) shown = true;
    });

    if (!shown) panels.forEach((p) => { p.hidden = true; });
  };

  const initPicker = (picker) => {
    const infos = picker.querySelectorAll('[data-explanation-info]');
    if (!infos.length) return;

    const updateAll = () => infos.forEach(updateInfo);

    picker.addEventListener('change', updateAll);
    picker.addEventListener('on:variant:change', updateAll);

    updateAll();
  };

  const initAll = () => {
    document.querySelectorAll('variant-picker').forEach(initPicker);
  };

  document.addEventListener('DOMContentLoaded', initAll);

  // Für Quick-add / dynamisch geladene Sections
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('variant-picker')) initPicker(node);
        node.querySelectorAll?.('variant-picker').forEach(initPicker);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
